import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { createSlug } from "../utils/slug";

const TextImageLayout = ({
  images = [],
  title,
  subtitle,
  description,
  buttonText,
  buttonLink,
}) => {
  const navigate = useNavigate();

  const getImagePath = (image) => {
    // Handle both string paths and object with image property
    return typeof image === "object" && image.image ? image.image : image;
  };

  const handleImageClick = (e, image) => {
    e.preventDefault();
    e.stopPropagation();

    // image can be a string (path) or an object with { image: path, offer_id: id, name: name }
    if (typeof image === "object") {
      const offerName = image.name || null;
      const offerId = image.offer_id || null;
      
      if (offerName && offerId) {
        // Include both slug (for SEO) and offer_id (for immediate API call)
        const slug = createSlug(offerName);
        navigate(`/shop/default?offer=${encodeURIComponent(slug)}&offer_id=${offerId}`);
      } else if (offerName) {
        const slug = createSlug(offerName);
        navigate(`/shop/default?offer=${encodeURIComponent(slug)}`);
      } else if (offerId) {
        // Fallback to offer_id if name is not available
        navigate(`/shop/default?offer_id=${offerId}`);
      }
    }
  };

  return (
    <section
      className="flat-spacing-12 text-image-layout-section"
      style={{ position: "relative", zIndex: 1, overflow: "visible" }}
    >
      <style>
        {`
          /* Prevent TextImageLayout from overlapping content below */
          .text-image-layout-section {
            position: relative !important;
            z-index: 1 !important;
            overflow: visible !important;
            margin-bottom: 0 !important;
          }
          
          .tf-img-with-text.img-text-3 {
            position: relative !important;
            z-index: 1 !important;
          }
          
          .tf-img-with-text .tf-image,
          .tf-img-with-text .tf-content-wrap {
            position: relative !important;
            z-index: 1 !important;
          }
          
          /* Ensure absolutely positioned items don't overflow section */
          .img-text-3-style-2 .grid-img-group .item-1,
          .img-text-3-style-2 .grid-img-group .item-3 {
            position: absolute !important;
            z-index: 2 !important;
          }
          
          /* Mobile: Reduce spacing and min-height */
          @media (max-width: 767px) {
            .text-image-layout-section.flat-spacing-12 {
              padding-top: 30px !important;
              padding-bottom: 30px !important;
            }
            
            .img-text-3-style-2 .grid-img-group {
              position: relative !important;
              min-height: auto !important;
              overflow: visible !important;
              margin-bottom: 0 !important;
              padding-bottom: 0 !important;
            }
            
            .img-text-3-style-2 .tf-image {
              padding: 15px 0px !important;
            }
          }
          
          /* Ensure proper spacing on desktop to prevent overlap */
          @media (min-width: 768px) {
            .text-image-layout-section {
              padding-bottom: 100px !important;
            }
            
            .img-text-3-style-2 .grid-img-group {
              position: relative !important;
              min-height: 600px !important;
              overflow: visible !important;
              margin-bottom: 60px !important;
              padding-bottom: 40px !important;
            }
          }
          
          @media (min-width: 1200px) {
            .text-image-layout-section {
              padding-bottom: 120px !important;
            }
            
            .img-text-3-style-2 .grid-img-group {
              min-height: 650px !important;
            }
          }
        `}
      </style>
      <div className="container">
        <div className="tf-grid-layout md-col-2 tf-img-with-text img-text-3 img-text-3-style-2">
          <div className="tf-image wow fadeInUp" data-wow-delay="0s">
            <div className="grid-img-group">
              {images.map((img, index) => (
                <div
                  key={index}
                  className={`box-img item-${
                    index + 1
                  } hover-img tf-image-wrap`}
                  onClick={(e) => handleImageClick(e, img)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="img-style">
                    <img
                      className="lazyload"
                      data-src={getImagePath(img)}
                      src={getImagePath(img)}
                      alt={`img-slider-${index + 1}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="tf-content-wrap wow fadeInUp" data-wow-delay="0s">
            {subtitle && (
              <p className="subheading text-uppercase fw-7">{subtitle}</p>
            )}
            {title && (
              <h2 className="heading fade-item fade-item-1 fw-6">{title}</h2>
            )}
            {description && (
              <p className="desc fade-item fade-item-2">{description}</p>
            )}
            {buttonText && (
              <Link
                to={buttonLink || "/shop/collection"}
                className="tf-btn btn-fill animate-hover-btn btn-icon radius-60"
              >
                <span>{buttonText}</span>
                <i className="icon icon-arrow-right"></i>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextImageLayout;
